import { render } from "./Overdue.vue?vue&type=template&id=0c1cae28&scoped=true"
import script from "./Overdue.vue?vue&type=script&lang=js"
export * from "./Overdue.vue?vue&type=script&lang=js"

import "./Overdue.vue?vue&type=style&index=0&id=0c1cae28&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1cae28"]])

export default __exports__